import { ComposerContainerContext } from '#pplx/frontend/composer-sdk/ComposerContainerContext.js';
import { useContext } from 'react';
/** Returns whether the caller renders inside a framed composer's attached header row. */
export function useIsInsideFramedHeader() {
    return useContext(ComposerContainerContext).isInsideFramedHeader;
}
//# sourceMappingURL=useIsInsideFramedHeader.js.map